import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

import CircularProgress from '@material-ui/core/CircularProgress';

interface LoadingProps {
  loadingText?: string;
}

//TODO: delay display of loader for 500ms
const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
`;

const LoadingText = styled.div`
  margin-left: 16px;
`;

export const Loading = ({ loadingText }: LoadingProps) => {
  const { t } = useTranslation();

  return (
    <Container aria-busy="true">
      <CircularProgress />
      <LoadingText>{loadingText || t('generic.loadingText')}</LoadingText>
    </Container>
  );
};

const LoadingOverlayContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoadingOverlay = (props: LoadingProps) => (
  <LoadingOverlayContainer>
    <Loading {...props} />
  </LoadingOverlayContainer>
);
